import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { Button } from '../../buttons/button';
import { ButtonType } from '../../buttons/button-types';
import { PopupStore } from '../popup.store';

export const DateSelectorPopup = observer<{ popupStore: PopupStore; children?: JSX.Element; styles: { [key: string]: string } }>(
  ({ popupStore, children, styles }: { popupStore: PopupStore; children?: JSX.Element; styles: { [key: string]: string } }) => {
    const currentDate = new Date();
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 6);

    return (
      <>
        <div id="row">
          <div className={styles.startDate}>
            <label>From</label>
            <DatePicker
              className={styles.dateInput}
              selected={popupStore.selectedDates.from?.toDate()}
              onChange={(date: Date | null) =>
                popupStore.changeSelectedDates({ ...popupStore.selectedDates, from: !date ? moment(minDate) : moment(date) })
              }
              dateFormat="dd MMMM yyyy"
              minDate={minDate}
              maxDate={popupStore.selectedDates.to?.toDate() ?? currentDate}
              onCalendarClose={() => popupStore.changeIsOpen(true)}
            ></DatePicker>
            <i className={`text-dark icon-calendar_32x32`}></i>
          </div>
          <div className={styles.endDate}>
            <label>To</label>
            <DatePicker
              className={styles.dateInput}
              selected={popupStore.selectedDates.to?.toDate()}
              onChange={(date: Date | null) =>
                popupStore.changeSelectedDates({ ...popupStore.selectedDates, to: !date ? moment(currentDate) : moment(date) })
              }
              dateFormat="dd MMMM yyyy"
              minDate={popupStore.selectedDates.from?.toDate() ?? minDate}
              maxDate={currentDate}
              onCalendarClose={() => popupStore.changeIsOpen(true)}
            ></DatePicker>
            <i className={`text-dark icon-calendar_32x32`}></i>
          </div>
        </div>
        <div className={`row ${styles.popupActionButtons}`}>
          {popupStore.config?.hasCancelButton && (
            <Button
              classes={[styles.popupButton]}
              meta={{ title: 'Cancel', name: 'Cancel', type: ButtonType.OutlineDark }}
              onClick={() => popupStore.defaultClose()}
            ></Button>
          )}
          {popupStore.config?.actionButton && (
            <Button classes={[styles.popupButton]} meta={popupStore.config?.actionButton} onClick={() => popupStore.onAction()}></Button>
          )}
        </div>
      </>
    );
  }
);